/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import './ManagerInfo.scss';

import defaultPicture from '../../../../../../assets/images/prof.svg';

const ManagerInfo = ({onClick}) => {
  const manager = useSelector((state) => state.customer ? state.customer.relationshipManager : null);

  const managerImage = _.isEmpty(manager.pictureUrl) ? defaultPicture : manager.pictureUrl;
  return (
    <div id="manager-info" onClick={onClick}>
      <div className="image-cropper" style={{backgroundImage: `url(${managerImage})`}}>
      </div>
      <div className="info">
        <p className="name">{ manager.fullName }</p>
        <p className="title">{ manager.jobTitle }</p>
        <p className="title">{ manager.officeLocation }</p>
      </div>
    </div>
  );
};

ManagerInfo.propTypes = {
  manager: PropTypes.object
};

export default ManagerInfo;
